import { ReactElement } from 'react';
import { PowerAssetChip } from '../PowerAssetChip';
import * as Icons from '../icons';
import { PowerOutput, PowerOutputStatus, PowerOutputType, isPowerOutputActive } from './types';

export const TYPE_ICONS: Record<PowerOutputType, ReactElement> = {
  [PowerOutputType.LOAD]: <Icons.Domain />,
  [PowerOutputType.LOADBANK]: <Icons.HeatPump />,
  [PowerOutputType.SOLAR]: <Icons.SolarPowerFilled />,
  [PowerOutputType.GENERATOR]: <Icons.OilBarrel />,
};

export const STATUS_ICONS: Record<Exclude<PowerOutputStatus, PowerOutputStatus.UNKNOWN>, ReactElement> = {
  [PowerOutputStatus.ACTIVE]: <Icons.CheckCircle fontSize="small" sx={{ color: 'success.main' }} />,
  [PowerOutputStatus.BUSY]: <Icons.Autorenew fontSize="small" />,
  [PowerOutputStatus.ERROR]: <Icons.Error fontSize="small" sx={{ color: 'error.main' }} />,
  [PowerOutputStatus.IDLE]: <Icons.Bedtime fontSize="small" />,
};

export function PowerOutputChip({ id, name, type, status = PowerOutputStatus.UNKNOWN, details = [] }: PowerOutput) {
  const statusColor = isPowerOutputActive(status) ? 'success.main' : 'grey.400';

  return (
    <PowerAssetChip
      id={id}
      name={name}
      icon={TYPE_ICONS[type]}
      statusIcon={status !== PowerOutputStatus.UNKNOWN ? STATUS_ICONS[status] : undefined}
      statusColor={statusColor}
      details={details}
      testId="power-output-chip"
    />
  );
}
